<nb-card>
  <nb-card-header>
    <h6>
      <span *ngIf="isReceive">{{ "warehouse.receiveStock" | translate }}</span>
      <span *ngIf="!isReceive">{{ "warehouse.issueStock" | translate }}</span>
      <!-- {{ finance.issueDate | date: "dd/MM/yyyy" }} -->
    </h6>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <table class="table table-sm table-borderless tbl-receipt-summary">
      <tr>
        <td colspan="2" class="col-title">
          <h6>
            {{ product.title }}
            <span *ngIf="product.unitName">({{ product.unitName }}) </span>
          </h6>
        </td>
      </tr>
      <tr>
        <td class="col-label">{{ "common.date" | translate }}</td>
        <td class="col-number">
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              placeholder="Chọn ngày"
              [nbDatepicker]="inventoryDate"
              [(ngModel)]="issueDate"
            />
            <nb-datepicker
              style="width: 120px"
              #inventoryDate
              format="dd/MM/yyyy"
            ></nb-datepicker>
          </nb-form-field>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.quantity" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <nb-form-field fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="productQuantityIncrement(-1)"
              >
                <nb-icon icon="minus-circle-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                fullWidth
                shape="semi-round"
                class="form-control"
                placeholder="Nhập số lượng"
                [status]="quantity > 0 ? 'primary' : 'danger'"
                [(ngModel)]="quantity"
                (change)="summaryDetail()"
              />
              <button
                nbSuffix
                nbButton
                ghost
                (click)="productQuantityIncrement(1)"
              >
                <nb-icon icon="plus-circle-outline"> </nb-icon>
              </button>
            </nb-form-field>
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.price" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá bán"
              [status]="price > 0 ? 'primary' : 'danger'"
              [(ngModel)]="price"
              (change)="summaryDetail()"
              (keydown.enter)="summaryDetail()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "common.amount" | translate }}:</td>
        <td class="col-number">
          <h6 class="text-primary">{{ amount | number }}</h6>
        </td>
      </tr>

      <tr>
        <td colspan="2" class="col-label">
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="{{ 'common.note' | translate }}"
            class="form-control"
            [(ngModel)]="prodInventory.comment"
          ></textarea>
        </td>
      </tr>
    </table>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="primary"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
